module.exports = __webpack_public_path__ + "static/media/waves_1.4b0c8c84.jpg";